/**
 * F-110: whether the platform socket is up, for code outside React (SDK
 * resources) that only polls while it is down. Written by RealtimeProvider.
 */
let connected = false

export const isRealtimeConnected = (): boolean => connected

export const setRealtimeConnected = (value: boolean): void => {
  connected = value
}
